/*globals jQuery */
( function( $ ) {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	window.MSR.profile = ( function() {
		var name,
			about;

		var init = function() {
			if ( ! $( 'body' ).hasClass( 'author' ) ) {
				return;
			}

			name = document.getElementById( 'js-profile-name' );
			about = document.getElementById( 'about' );

			if ( about ) {
				about.addEventListener( 'click', readMore );
			}

			if ( !name || name.length === 0 ) {
				return;
			}

			shrinkName();
		};

		var shrinkName = function() {
			var fullName,
				names;

			fullName = name.textContent;
			names    = fullName.split( ' ' );

			for ( var i = 0; i <= names.length; i++ ) {
				var currentName = names[i];

				if ( currentName && currentName.length > 12 ) {
					$( name ).addClass( 'shrink-name' );
				}
			}
		};

		var readMore = function( e ) {
			if ( e.target.classList.contains( 'more' ) ) {
				//Move to jQuery for better cross browser compatibility
				$( about.getElementsByClassName( 'short' )[0] ).remove();
				about.getElementsByClassName( 'full' )[0].classList.remove( 'hidden' );
			}
		};

		return {
			init: init
		};
	} )();

	/******* PROFILE PAGE *******/

	$( function() {
		window.MSR.profile.init();
	} );
} )( jQuery );
